import { Component, OnInit } from '@angular/core';
import { LanguageService } from '@app/shared/services/Language.service';

@Component({
  selector: 'app-base-auth',
  templateUrl: './base-auth.component.html',
  styleUrls: ['./base-auth.component.less']
})
export class BaseAuthComponent implements OnInit {
    selectedLanguage: string = 'en'; 
  constructor(private languageService:LanguageService) { }
  ngOnInit(): void {
    this.selectedLanguage= localStorage.getItem('app_lang') || 'en';
  }
    changeLanguage(lang: string) {
    localStorage.setItem('app_lang', lang);
    this.languageService.setLanguage(lang);
  }
}
